import React, { useEffect, useState } from "react";
import { collection, query, where, getDocs, doc, getDoc } from "firebase/firestore";
import { db, auth } from "../firebase";
import Layout from "../components/layout/Layout";
import { useNavigate } from "react-router-dom";
import BackHomeButton from "../components/BackHomeButton";

function Recent_Activity() {
  const navigate = useNavigate();

  const [recentActivity, setRecentActivity] = useState([]);
  const [loading, setLoading] = useState(true);

  const [profileExists, setProfileExists] = useState(false);
  const [userName, setUserName] = useState("");
  const [persona, setPersona] = useState("");

  // ✅ Fetch Profile
  useEffect(() => {
    const fetchProfile = async () => {
      const currentUser = auth.currentUser;
      if (!currentUser) {
        navigate("/login");
        return;
      }

      const profileRef = doc(db, "profiles", currentUser.uid);
      const profileSnap = await getDoc(profileRef);

      if (profileSnap.exists()) {
        const data = profileSnap.data();
        setProfileExists(true);
        setUserName(data.name || "");
        setPersona(data.persona || "");
      } else {
        setProfileExists(false);
        navigate("/create-profile");
      }
    };

    fetchProfile();
  }, [navigate]);

  // ✅ Fetch Recent Activity
  useEffect(() => {
    const fetchRecentActivity = async () => {
      const currentUser = auth.currentUser;
      if (!currentUser) return;

      try {
        const worksheetsSnap = await getDocs(
          query(
            collection(db, "ai_generated_worksheets"),
            where("userId", "==", currentUser.uid)
          )
        );

        const worksheetsData = worksheetsSnap.docs.map(doc => ({
          id: doc.id,
          type: "AI Worksheet Generated",
          subject: doc.data().subject,
          lesson: doc.data().lesson,
          timestamp: doc.data().timestamp?.toDate() || new Date(0),
          imageSrc: "/bot.png",
        }));

        const quizzesSnap = await getDocs(
          query(
            collection(db, "AI_Results"),
            where("uid", "==", currentUser.uid)
          )
        );

        const quizzesData = quizzesSnap.docs.map(doc => ({
          id: doc.id,
          type: "AI Quiz",
          subject: doc.data().subject,
          lesson: doc.data().lesson,
          score: doc.data().score,
          totalQuestions: doc.data().totalQuestions,
          timestamp: doc.data().timestamp?.toDate() || new Date(0),
          imageSrc: "/ai_quiz.png",
        }));

        const DownloadSnap = await getDocs(
          query(
            collection(db, "Downloads_And_Generations"),
            where("userId", "==", currentUser.uid),
            where("action","==","Download")
          )
        );

        const DownloadsData = DownloadSnap.docs.map(doc => ({
          id: doc.id,
          type: "Download Worksheet",
          subject: doc.data().subject,
          standard: doc.data().standard,
          //type: doc.data().type,
          fileName: doc.data().fileName,
          timestamp: doc.data().timestamp?.toDate() || new Date(0),
          imageSrc: "/Parent_Worksheet.png",
        }));

        const merged = [...worksheetsData, ...quizzesData, ...DownloadsData]
          .sort((a, b) => b.timestamp - a.timestamp);

        setRecentActivity(merged);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching activity:", error);
        setLoading(false);
      }
    };

    fetchRecentActivity();
  }, []);

  return (
    <>

    
      <div className="max-w-5xl mx-auto px-6 py-8">
        <BackHomeButton/>
        <br></br>
        <br></br>
        <h2 className="text-2xl font-semibold text-gray-800 mb-6">
          📄 My Recent Activity
        </h2>

        {loading ? (
          <p className="text-gray-500">Loading activity...</p>
        ) : recentActivity.length === 0 ? (
          <p className="text-gray-500">No recent activity found.</p>
        ) : (
          <div className="bg-white rounded-2xl shadow-sm p-4 space-y-2">
            {recentActivity.map(item => (
              <ActivityItem key={item.id} {...item} />
            ))}
          </div>
        )}
      </div>
    </>
  );
}

function ActivityItem({
  type,
  subject,
  lesson,
  score,
  totalQuestions,
  timestamp,
  imageSrc
}) {
  return (
    <div className="flex items-start gap-4 p-4 hover:bg-gray-50 rounded-xl transition">
      <div className="w-14 h-14 rounded-full bg-gray-100 flex items-center justify-center overflow-hidden">
        <img src={imageSrc} alt={type} className="w-full h-full object-cover" />
      </div>

      <div className="flex flex-col">
        <h4 className="font-semibold text-gray-800">{type}</h4>
        <p className="text-sm text-gray-500">
          {subject} {lesson && `- ${lesson}`}
        </p>

        {type === "AI Quiz" && score !== undefined && (
          <span className="text-xs text-gray-400 mt-1">
            Score: {score}/{totalQuestions}
          </span>
        )}

        <span className="text-xs text-gray-400 mt-1">
          {timestamp.toLocaleString()}
        </span>
      </div>
    </div>
  );
}

export default Recent_Activity;